export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-2xl p-8 md:p-12 border border-background-200/60 flex flex-col md:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
              移动观影更自由
            </h2>
            <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-md">
              夫妻影院适配手机、平板全设备，躺在床上也能畅快追剧。
              支持投屏到电视，大屏观影更尽兴。添加到手机桌面，像 App 一样方便使用。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-3">
              <a
                href="/"
                onClick={(e) => e.preventDefault()}
                className="px-6 py-2.5 bg-foreground-900 text-background-50 text-sm font-medium rounded-lg hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-smartphone-line"></i>
                </span>
                添加到桌面
              </a>
              <span className="text-xs text-foreground-400">无需下载，打开浏览器即可使用</span>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="relative w-44 h-80 rounded-2xl overflow-hidden border-4 border-background-300 shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=A%20smartphone%20mockup%20showing%20a%20TV%20drama%20streaming%20app%20interface%20on%20screen%2C%20clean%20modern%20UI%20with%20drama%20posters%20and%20playlist%20layout%2C%20warm%20color%20theme%20with%20burgundy%20and%20cream%20tones%2C%20minimalist%20design%2C%20isolated%20on%20soft%20warm%20background%2C%20product%20photography%20style%2C%20subtle%20shadow&width=600&height=1100&seq=app-mobile-2026&orientation=portrait"
                alt="夫妻影院移动端观影"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}